<script>
import {permissionMixin} from "@/mixins/permissionMixins";
import {PaginationMixin} from "@/mixins/PaginationMixin";
import PscIndex from "@/components/modules/psc/PscIndex.vue";
import loading from "@/components/elements/AppLoading.vue";
import AppLoading from "@/components/elements/AppLoading.vue";
import {mapActions, mapGetters} from "vuex";
import {VesselService} from "@/services/VesselService";

export default {
  name: "ShipsPiPSCNumberInspection",
  mixins: [PaginationMixin, permissionMixin],
  data(){
    return {
      loading : true,
      params : {
        fleet_id: null,
      },
      globalIndex: 1,
      recGlobalIndex: null,
      inspections: [],
      inspectionSelectedModal: null,
      inspectionSelectedTitle: null,
    }
  },
  components: {
    PscIndex,
    loading,
    AppLoading,
  },
  mounted: function() {
    this.globalIndex = 1;
  },
  methods : {
    ...mapActions([
      'getVesselsPscInspections',
      'getPscReports'
    ]),

    async setData(page = 1) {
      this.loading = true;
      this.params.page = page;
      await this.getVesselsPscInspections(this.params);
      this.loading = false;
    },

    async getActiveTab(data){
      var page = 1;
      this.params.search = '';
      this.setData(page);
      this.activeTab = data;
    },

    showInspectionModal(type, data, title, year) {
      this.inspections = data;
      this.inspectionSelectedModal = type;
      this.inspectionSelectedTitle = title+"("+year+")";
      $('#inspectionModal').modal('show');
    },

    async goToPscInspection (reportId) {
      const route= this.$router.resolve(
        {
          name: 'PscMain',
          params: {
            id: reportId,
          },
        },
      )
      window.open(route.href,'_blank')
    },

    async exportToExcel(){
      swal.fire({
        'title': `LOADING...`,
        text: 'Please wait while the system exports the data.',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()
      const downloadResponse = await VesselService.downloadVesselPscInspectionYearlyCount(this.params);
      swal.close()
      let url = window.URL.createObjectURL(new Blob([downloadResponse.data],{type:'application/vnd.ms-excel'}))
      const date = new Date().toISOString().split("T")[0];
      let filename=`PSC_Number_of_Inspection_${date}.xlsx`;
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },

    // goToPscInspection(data){
    //   window.open('/psc/'+data+'/general','_blank');
    // },

    getGlobalIndex(data) {
      if(data === 1){
        this.globalIndex = data+1;
      }
      else{
        this.globalIndex++;
      }
      return this.globalIndex;
    },
  },
  computed: {
    ...mapGetters([
      'vesselPscInspectionInspections',
      'pagination',
      'fleetKeys',
      'reports'
    ]),
  },

  watch: {
    'params.search'() {
      this.setVesselsData()
    },
    'params.fleet_id'() {
      this.setData()
    },
  },

  async created() {
    this.setVesselsData = _.debounce(this.setData, 750)
    await this.setData();
  },
}
</script>

<template>
  <div class="card mt-3 mb-3 mb-0 border">
    <div class="card-body">
      <div class="row">
        <div class="col-4">
          <nav aria-label="...">
            <ul class="pagination text-smallest mb-0 pb-0">
              <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
                <button class="page-link" @click="setData(1)">First</button>
              </li>

              <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
                <button class="page-link" @click="setData(page)">{{ page }}</button>
              </li>

              <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
                <button class="page-link" @click="setData(pagination.lastPage)">Last</button>
              </li>
            </ul>
          </nav>
        </div>
        <div class="col-3 pr-0">
          <div class="row">
            <div class="col-4 pr-0 text-right">
              <label class="col-form-label font-weight-bold">Filter By: </label>
            </div>
            <div class="col-8">
              <select class="form-control form-control-sm text-uppercase" id="fleetList" v-model="params.fleet_id" :disabled="loading">
                <option :value="null">-- ALL FLEET --</option>
                <template v-for="fleet in fleetKeys">
                  <option :value="fleet.id" v-if="fleet?.name !== 'N/A' && fleet.code !== 'N/A'">
                    {{fleet.name ? fleet.name.toUpperCase() : ''}}
                  </option>
                </template>
              </select>
            </div>
          </div>
        </div>
        <div class="col-5">
          <div class="row pr-2" v-if="['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
            <div class="col-8 pr-0">
              <input type="text" name="vesselSearch" class="form-control form-control-sm" v-model="params.search" placeholder="Search Vessel" :disabled="loading">
            </div>
            <div class="col-4 pl-0 align-content-center">
              <button v-if="vesselPscInspectionInspections.length" class="ml-2 mr-2 e-btn force-white-all w-100" @click="exportToExcel" :disabled="loading" :class="loading ? 'e-btn-blue-gray cursor-not-allowed' : 'e-btn-primary'">
                <font-awesome-icon class="mr-1" icon="download"/>
                Download
              </button>
              <button v-else class="ml-2 mr-2 e-btn force-white-all w-100 e-btn-blue-gray cursor-not-allowed">
                <font-awesome-icon class="mr-1" icon="download"/>
                Download
              </button>
            </div>
          </div>
          <div class="row pr-2" v-else>
            <div class="col-12 pr-1">
              <input type="text" name="vesselSearch" class="form-control form-control-sm" v-model="params.search" placeholder="Search Vessel" :disabled="loading">
            </div>
          </div>
        </div>
      </div>
      <hr style="border-bottom: 2px solid black">
      <div class="row">
        <div class="col-12">
          <div class="table-responsive table-inspection" style="max-height: 60vh;">
            <table class="table table-bordered mb-0 dark-border">
              <template v-if="loading">
                <tbody>
                <tr>
                  <td>
                    <div class="card">
                      <div class="card-body text-center">
                        <app-loading></app-loading>
                      </div>
                    </div>
                  </td>
                </tr>
                </tbody>
              </template>
              <template v-else-if="!loading && !vesselPscInspectionInspections.length">
                <tbody>
                <tr>
                  <td>
                    <div class="card" style="background-color: #e1e1e1">
                      <div class="card-body text-center">
                        <span class="font-weight-bold h6" style="color: black">NO RESULTS FOUND</span>
                      </div>
                    </div>
                  </td>
                </tr>
                </tbody>
              </template>
              <template v-else>
                <thead>
                <tr>
                  <th class="text-uppercase font-weight-bold text-center align-middle inspection-headers dark-bottom-side-border" style="max-width: 200px !important;" rowspan="3">Vessel Name</th>
                  <th v-for="(data, index) in vesselPscInspectionInspections[0]?.psc" class="text-uppercase font-weight-bold text-center align-middle inspection-headers dark-bottom-side-border" colspan="2">{{data.year}}</th>
                </tr>
                <tr>
                  <template v-for="(data, index) in vesselPscInspectionInspections[0]?.psc">
                    <th class="text-center align-middle text-uppercase inspection-headers dark-bottom-side-border">Total Number of Psc Inspection</th>
                    <th class="text-center align-middle text-uppercase deficiency-ins-headers dark-bottom-side-border">Deficiency Inspection</th>
                  </template>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data, index) in vesselPscInspectionInspections" :key="index">
                  <td class="text-uppercase font-weight-bold text-right align-middle normal-headers dark-right-side-border" style="min-width: 170px !important;">{{ data.name }}</td>
                  <template v-for="(item, indexPsc) in data.psc">
                    <td class="text-center font-weight-bold align-middle text-primary h5" style="cursor:pointer;" v-if="item.psc.nbr_without_deficiency.length !== 0" @click="showInspectionModal('nbrInspection',item.psc.nbr_without_deficiency,data.name,item.year)">
                      {{item.psc.nbr_without_deficiency.length}}
                    </td>
                    <td class="text-center font-weight-bold align-middle" v-else>
                      {{item.psc.nbr_without_deficiency.length}}
                    </td>
                    <td :class="['text-center align-middle', {'border-right-black':indexPsc !== (data?.psc?.length -1)}]" style="cursor:pointer;" v-if="item.psc.nbr_with_deficiency.length !== 0" @click="showInspectionModal('defInspection',item.psc.nbr_with_deficiency,data.name,item.year)">
                              <span class="h5 font-weight-bold" :style="{ color: item.psc.nbr_with_deficiency.some(nbr => nbr.psc_deficiencies.some(def => def.action_code?.code === '30')) ? 'red' : '#007bff' }">
                                  {{ item.psc.nbr_with_deficiency.length }}
                              </span>
                    </td>
                    <td :class="['text-center font-weight-bold align-middle', {'border-right-black':indexPsc !== (data?.psc?.length -1)}]" v-else>{{item.psc.nbr_with_deficiency.length}}</td>
                  </template>
                </tr>
                </tbody>
              </template>
            </table>
          </div>
        </div>
      </div>
      <!--INSPECTION MODAL-->
      <div class="modal fade" id="inspectionModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xxl modal-dialog-centered" style="max-width: 80vw;">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title my-auto font-weight-bold text-uppercase" id="exampleModalLabel">{{ this.inspectionSelectedTitle }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                  <table class="table table-bordered w-100">
                    <thead>
                    <tr v-if="this.inspectionSelectedModal === 'nbrInspection'">
                      <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">#</th>
                      <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Code</th>
                      <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Report Title</th>
                      <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Inspection Date</th>
                      <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Action</th>
                    </tr>
                    <tr v-else>
                      <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">#</th>
                      <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Code</th>
                      <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Title</th>
                      <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Deficiency Code</th>
                      <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Deficiency Description</th>
                      <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Inspection Date</th>
                      <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Action Code</th>
                      <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-if="this.inspectionSelectedModal === 'nbrInspection'">
                      <tr v-for="(data, index) in inspections">
                        <td class="align-middle text-center">{{index+1}}</td>
                        <td class="align-middle text-center">{{data.code}}</td>
                        <td class="align-middle text-center">{{data.title}}</td>
                        <td class="align-middle text-center">{{data.inspection_date}}</td>
                        <td class="align-middle text-center">
                          <button class="e-btn e-btn-blue e-btn-sm e-text-white" @click="goToPscInspection(data.id)">
                            <font-awesome-icon icon="eye"  />
                            View
                          </button>
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <template v-for="(data, index) in inspections">
                        <tr v-for="(item, indexDef) in data.psc_deficiencies">
                          <template v-if="indexDef === 0">
                            <td class="align-middle text-center no-rows" :rowspan="data.psc_deficiencies.length">{{index+1}}</td>
                            <td class="align-middle text-center" :rowspan="data.psc_deficiencies.length">{{data.code}}</td>
                            <td class="align-middle text-center" :rowspan="data.psc_deficiencies.length">{{data.title}}</td>
                          </template>
                          <td class="align-middle text-center">{{item.code.code}}</td>
                          <td class="align-middle text-center">{{item.description}}</td>
                          <template v-if="indexDef === 0">
                            <td class="align-middle text-center" :rowspan="data.psc_deficiencies.length">{{data.inspection_date}}</td>
                          </template>
                          <td class="align-middle text-center">{{item.action_code?.code}}</td>
                          <td class="align-middle text-center">
                            <button class="e-btn e-btn-blue e-btn-sm e-text-white" @click="goToPscInspection(data.id)">
                              <font-awesome-icon icon="eye"  />
                              View
                            </button>
                          </td>
                        </tr>
                      </template>
                    </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--END INSPECTION MODAL  -->
    </div>
  </div>
</template>

<style scoped>
.table-inspection td:nth-child(1),
.table-inspection th
{
  position: sticky;
  left: 0;
  z-index: 5;
}
.table-inspection th{
  z-index: 10;
}
.table-inspection tr:nth-child(1) th:nth-child(1){
  z-index: 99;
}
.table-inspection tr:nth-child(1) th,
.table-inspection td:nth-child(1)
{
  outline-offset: -1px ;
}
.table-inspection tr:nth-child(1) th {  outline: 3px solid #b3b3b3 ; }
.table-inspection td:nth-child(1) { outline: 2px solid #b3b3b3 ; }
.table-inspection tr:nth-child(1) th {  top:0; }
.table-inspection tr:nth-child(2) th{ top:43px; }
.inspection-headers{
  background-color: #2E75B5;
  color: #f2f2f2;
}
.deficiency-ins-headers{
  background-color: #C55911;
  color: #f2f2f2;
}
.normal-headers{
  background-color: #e1e1e1;
  border: 1px solid #c3c3c3;
}
.dark-left-side-border{
  border-left: 3px solid #b3b3b3;
}
.dark-right-side-border{
  border-right: 3px solid #b3b3b3;
}
.dark-bottom-side-border{
  border-bottom: 3px solid #b3b3b3;
}
.dark-top-side-border{
  border-top: 3px solid #b3b3b3;
}
.dark-border{
  border: 3px solid #b3b3b3;
}
.border-right-black {
  border-right: 3px solid black ;
}
</style>
